import React, { PropsWithChildren, PureComponent } from 'react';
import { Provider } from 'react-redux';

import { getAppStore } from 'helpers/utils';

export class StoreProvider extends PureComponent<PropsWithChildren> {
  private store = getAppStore();

  public render() {
    return <Provider store={this.store}>{this.props.children}</Provider>;
  }
}
